import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import { collection, getDocs, getFirestore, query, where } from 'firebase/firestore';
import firebaseApp from '../../../utils/firebaseConfig';
import { LAYAWAY_STATUS, effectiveStatus, firearmLabel, fmtDate, formatPrice } from '../../../utils/layaways';
import LayawayCreateDialog from './LayawayCreateDialog';

const db = getFirestore(firebaseApp);

// Layaways del cliente dentro de su cuenta (Users → usuario).
export default function MemberLayawaysCard({ member }) {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);

  const load = useCallback(async () => {
    if (!member || !member.id) return;
    try {
      const seen = new Map();
      const a = await getDocs(query(collection(db, 'layaways'), where('memberId', '==', member.id)));
      a.docs.forEach((d) => seen.set(d.id, { id: d.id, ...d.data() }));
      const digits = String(member.phone || '').replace(/\D/g, '');
      if (digits.length >= 7) {
        const b = await getDocs(query(collection(db, 'layaways'), where('memberPhone', '==', digits)));
        b.docs.forEach((d) => seen.set(d.id, { id: d.id, ...d.data() }));
      }
      setRows(Array.from(seen.values()).sort((x, y) => (y.createdAt?.seconds || 0) - (x.createdAt?.seconds || 0)));
    } catch (e) { console.error('member layaways', e); }
  }, [member]);

  useEffect(() => { load(); }, [load]);

  if (!member || !member.id) return null;
  const openOnes = rows.filter((l) => ['active', 'overdue', 'paid'].includes(effectiveStatus(l)));

  return (
    <Card>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="h6">Layaways de armas</Typography>
          <Button size="small" variant="contained" onClick={() => setOpen(true)}>Nuevo layaway / custodia</Button>
        </Stack>
        {rows.length === 0 && <Typography variant="body2" color="text.secondary">Este cliente no tiene layaways.</Typography>}
        {rows.map((l) => {
          const st = effectiveStatus(l); const meta = LAYAWAY_STATUS[st];
          return (
            <Stack key={l.id} direction="row" justifyContent="space-between" alignItems="center" sx={{ py: 1, borderBottom: '1px dashed', borderColor: 'divider', cursor: 'pointer' }} onClick={() => navigate(`/dashboard/layaways/details?id=${l.id}`)}>
              <div>
                <Typography variant="subtitle2">{firearmLabel(l)}</Typography>
                <Typography variant="caption" color="text.secondary">{l.kind === 'custody' ? `pagado hasta ${fmtDate(l.dueDate)}` : `Serie ${l.serialNumber || '—'} · límite ${fmtDate(l.dueDate)}`}</Typography>
              </div>
              <Stack alignItems="flex-end">
                <Typography variant="subtitle2" color={l.balanceCents > 0 ? 'error.main' : 'success.main'}>{l.kind === 'custody' ? `${l.storageMonths || 0} mes(es)` : formatPrice(l.balanceCents)}</Typography>
                <Chip size="small" color={meta.color} label={meta.label} />
              </Stack>
            </Stack>
          );
        })}
        {openOnes.length > 0 && <Typography variant="caption" color="text.secondary" display="block" mt={1}>El cliente puede abonar desde la app (Perfil → Mis Layaways) o en bbtc-dashboard.web.app/layaways.</Typography>}
      </CardContent>
      <LayawayCreateDialog open={open} onClose={() => setOpen(false)} member={member} onCreated={(id) => navigate(`/dashboard/layaways/details?id=${id}`)} />
    </Card>
  );
}

MemberLayawaysCard.propTypes = { member: PropTypes.object };
